export default __webpack_public_path__ + "static/media/07.4c72184c.svg";